import React, { Component } from 'react';
import { Card, message } from 'antd';
import { BackBtn } from '@comm/BackBtn';
import { queryIncCustomInfo } from '@api/incubator/custom';
import { querySaveAccount, querySaveCustom } from '@api/common/custom';
import CardBase from './CardBase';
import CardAccount from './CardAccount';
import CardProject from './CardProject';
import CardFile from './CardFile';
import ModalAccount from './ModalAccount';
import ModalBase from './ModalBase';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customInfo: {},
      visible: false,
      baseVisible: false,
    };
  }

  componentDidMount() {
    this.getIncCustomInfo();
  }

  getIncCustomInfo = () => {
    queryIncCustomInfo({
      customUuid: this.props.params.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          customInfo: res.data,
        });
      }
    });
  };

  editCustom = params => {
    querySaveCustom({
      ...params,
      uuid: this.props.params.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncCustomInfo();
        this.handleBaseVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  editCustomAccount = params => {
    querySaveAccount({
      ...params,
      uuid: this.props.params.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncCustomInfo();
        this.handleVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleBaseVisible = flag => {
    this.setState({
      baseVisible: !!flag,
    });
  };

  render() {
    const { customUuid } = this.props.params;
    const { customInfo, visible, baseVisible } = this.state;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
        </div>
        <Card
          title="基本信息"
          style={{ marginBottom: '16px' }}
          extra={<a onClick={() => this.handleBaseVisible(true)}>编辑</a>}
        >
          <CardBase {...this.props} customInfo={customInfo} refresh={this.getIncCustomInfo} />
        </Card>
        <Card
          title="账户信息"
          style={{ marginBottom: '16px' }}
          extra={<a onClick={() => this.handleVisible(true)}>编辑</a>}
        >
          <CardAccount accountInfo={customInfo} />
        </Card>
        <Card title="项目介绍" style={{ marginBottom: '16px' }}>
          <CardProject {...this.props} />
        </Card>
        <CardFile customUuid={customUuid} />
        {visible ? (
          <ModalAccount
            onCancel={this.handleVisible}
            onSubmit={this.editCustomAccount}
            data={customInfo}
          />
        ) : null}
        {baseVisible ? (
          <ModalBase
            onCancel={this.handleBaseVisible}
            onSubmit={this.editCustom}
            data={customInfo}
          />
        ) : null}
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/Index.js